<template>
  <section>
    <md-app md-waterfall md-mode="fixed" class="c-form">
      <md-app-toolbar md-elevation="4" class="u-fixed md-dense">
        <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <topbarmenu :show-links="['account', 'overview']"></topbarmenu>
      </md-app-toolbar>
      <md-app-drawer :md-active.sync="menuVisible">
        <drawermenu></drawermenu>
      </md-app-drawer>
      <md-app-content class="o-modal--bordered">
        <branding class="small"></branding>
        <article class="c-article">
          <transition name="fade">
            <div v-if="response" key="response">
              <h2 class="c-article__heading success">{{ response }}</h2>
            </div>
            <div v-else key="clear">
              <h2 class="c-article__heading">Wij horen graag van jou!</h2>
              <p class="u-txt-centered">
                Wil je feedback geven op deze app of een onderdeel ervan? Heb je vragen of suggesties?<br />Vul het formulier in en wij gaan ermee aan de slag.
              </p>
            </div>
          </transition>
        </article>
        <form novalidate @submit.prevent="validateForm" class="md-layout md-alignment-center-space-between md-gutter">
          <div class="md-layout-item md-size-50">
            <md-field :class="getValidationClass('name')">
              <label>Naam</label>
              <md-input v-model="form.name" type="text" name="name" :disabled="sending"></md-input>
              <span class="md-error" v-if="!$v.form.name.required">Naam is verplicht</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field :class="getValidationClass('email')">
              <label>E-mail</label>
              <md-input v-model="form.email" type="email" name="address" :disabled="sending"></md-input>
              <span class="md-error" v-if="!$v.form.email.required">E-mail adres is verplicht</span>
              <span class="md-error" v-else-if="!$v.form.email.email">Dit is geen geldig e-mail adres</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field :class="[{ filled: form.message && form.message.length > 0 }, getValidationClass('message')]" :disabled="sending">
              <label>Bericht</label>
              <wc-textarea v-model="form.message" name="message"></wc-textarea>
              <span class="md-error" v-if="!$v.form.message.required">Het is verplicht een bericht achter te laten.</span>
            </md-field>
          </div>
          <div class="md-layout-item md-layout-item--flex md-size-100">
            <p class="u-txt--modest">
              Deze site wordt beschermd door reCAPTCHA. Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> &
              <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Terms of Service</a> zijn hier van toepassing.
            </p>
            <div id="recaptcha" class="g-recaptcha"></div>
            <md-button type="submit" :md-ripple="false" class="md-primary md-raised" :disabled="sending">verzenden</md-button>
          </div>
        </form>
      </md-app-content>
    </md-app>
  </section>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

import { gRecaptcha } from "../config";
import checkAndSend, { initRecaptcha } from "../init/mail.init";

import { translate, scripts, googleTags } from "../mixins";

import drawermenu from "./partials/MenuDrawer";
import topbarmenu from "./partials/MenuTopbar";
import branding from "./partials/Branding";
import wcTextArea from "./elements/WcTextArea";

export default {
  name: "Feedback",
  mixins: [validationMixin, translate, scripts, googleTags],
  components: {
    drawermenu,
    topbarmenu,
    branding,
    "wc-textarea": wcTextArea
  },
  computed: {},
  mounted() {
    this.recaptchaScript = this.loadScript(`//www.google.com/recaptcha/api.js?render=${gRecaptcha.sitekey}`, "recaptchascript");
    this.gTagScreenView("Feedback");
  },
  destroyed() {
    this.unLoadScript(this.recaptchaScript);
  },
  data() {
    return {
      menuVisible: false,
      userActions: false,
      recaptchaScript: null,
      form: this.emptyForm(),
      sending: false,
      response: null
    };
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      message: { required }
    }
  },
  methods: {
    emptyForm() {
      return {
        name: "",
        email: "",
        message: ""
      };
    },
    resetForm() {
      this.$v.$reset();
      this.form = this.emptyForm();
      this.sending = false;
      setTimeout(() => {
        this.response = null;
      }, 2000);
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
      return false;
    },
    async sendMail() {
      this.sending = true;
      initRecaptcha();
      const response = await checkAndSend("sendEmailCF", JSON.parse(JSON.stringify(this.form)));
      if (response) {
        this.response = "Bedankt. Je bericht is verzonden.";
        this.resetForm();
      }
    },
    validateForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.sendMail();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/libs.vuematerial-forms.scss";

.o-modal--bordered {
  margin: 100px auto;
}

.c-article {
  position: relative;
  height: 180px;

  @media (min-width: 600px) {
    height: 100px;
  }

  & > div {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.md-layout-item--flex {
  display: flex;
  justify-content: flex-end;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.5s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
